
import {
  FETCH_ALL_MERCHANTS_FULFILLED,
  SELECT_MERCHANT
} from '../actions/MerchantsCreators';
import _ from 'lodash';

export const MerchantsReducer = (state = {
  merchantList: {},
  selectMerchant: [],
  allMerchants: []
}, action) => {
  switch (action.type) {
    case FETCH_ALL_MERCHANTS_FULFILLED:
      const newState = {
        ...state,
        allMerchants: action.payload.data.merchants,
        merchantList: _.mapKeys(action.payload.data.merchants, 'id')
      };
      return newState;
    case SELECT_MERCHANT:
      return {
        ...state,
        selectMerchant: action.payload
      };
    default:
  }
  return state;
}
